export const CONCEPT_NO_TITLE = 'No title yet';

const EXCERPT_LENGTH = 60;

function excerpt(text: string): string {
  const flat = text.replace(/\s+/g, ' ').trim();
  if (flat.length <= EXCERPT_LENGTH) return flat;
  const cut = flat.slice(0, EXCERPT_LENGTH);
  const lastSpace = cut.lastIndexOf(' ');
  return `${(lastSpace > 20 ? cut.slice(0, lastSpace) : cut).trimEnd()}…`;
}

export function conceptTitle(parts: {
  hook?: string | null;
  topic?: string | null;
  summary?: string | null;
  rationale?: string | null;
}): string {
  const named = parts.hook?.trim() || parts.topic?.trim();
  if (named) return named;
  const written = parts.summary?.trim() || parts.rationale?.trim();
  return written ? excerpt(written) : CONCEPT_NO_TITLE;
}
